<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

const emit = defineEmits<{ (event: 'intersected'): void }>()

const observerRef = ref<HTMLDivElement>()
const observerInstance = ref<IntersectionObserver>()

let intersectionTimeout: number

onMounted(() => {
  observerInstance.value = new window.IntersectionObserver(([entry]) => {
    if (entry?.isIntersecting) {
      intersectionTimeout = window.setTimeout(() => {
        emit('intersected')
      }, 100)
    } else {
      window.clearTimeout(intersectionTimeout)
    }
  })

  if (observerRef.value) {
    observerInstance.value.observe(observerRef.value)
  }
})

onBeforeUnmount(() => observerInstance.value?.disconnect())
</script>

<template>
  <div ref="observerRef" class="tw-h-1" />
</template>
